import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed } from 'vue';

import { RentabilityHeader } from './components/RentabilityHeader';
import { PerformanceChart } from '@/modules/wealth/components/PerformanceChart';
import { PerformanceLink } from './components/PerformanceLink';

import {
  getPortfolioChart,
  PortfolioChartAxisX,
  PortfolioChartAxisY,
  PortfolioChartFilter,
  PortfolioChartParams,
  PortfolioChartSummary
} from '@/modules/wealth/services/portfolio';
import { getFilterOptions } from '@/modules/wealth/views/IndexPortfolio/helpers';

interface Props {
  portfolioId: string;
  isLoadingPortfolio?: boolean;
  hasErrorPortfolio?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RentabilityChart',
  props: {
    portfolioId: null,
    isLoadingPortfolio: { type: Boolean },
    hasErrorPortfolio: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
  isLoadingPortfolio?: boolean;
  hasErrorPortfolio?: boolean;
};



const isLoading = ref(false);
const hasError = ref(false);
const periodFilters = ref<PortfolioChartFilter[]>([]);
const benchmarkFilters = ref<PortfolioChartFilter[]>([]);
const portfolioChartSummary = ref<PortfolioChartSummary | null>(null);
const chartAxisX = ref<PortfolioChartAxisX[]>([]);
const chartAxisY = ref<PortfolioChartAxisY[]>([]);
const isChartAnimationInProgress = ref(false);

const portfolioParams = computed<PortfolioChartParams>(() => {
  return {
    portfolioId: props.portfolioId,
    periodFilter: getActiveFilter(periodFilters.value),
    benchmark: getActiveFilter(benchmarkFilters.value)
  };
});

const isChartLoading = computed(() => {
  return (
    isLoading.value &&
    chartAxisX.value.length === 0 &&
    chartAxisY.value.length === 0
  );
});

const isHeaderLoading = computed(() => {
  return isLoading.value || isChartAnimationInProgress.value;
});

const getPortfolioChartData = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    const portfolioChart = await getPortfolioChart(portfolioParams.value);

    periodFilters.value = getFilterOptions(portfolioChart.periodFilters);
    benchmarkFilters.value = getFilterOptions(portfolioChart.benchmarks);
    portfolioChartSummary.value = portfolioChart.summary;
    chartAxisX.value = portfolioChart.axisX;
    chartAxisY.value = portfolioChart.axisY;
  } catch (error) {
    hasError.value = true;
    isChartAnimationInProgress.value = false;
  } finally {
    isLoading.value = false;
  }
};

const handlePeriodFilterChange = async (value: string) => {
  periodFilters.value = periodFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));
  getPortfolioChartData();
};

const handleBenchmarkFilterChange = async (value: string) => {
  benchmarkFilters.value = benchmarkFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));
  await getPortfolioChartData();
};

const handleOnAnimationStateChange = (isAnimationInProgress: boolean) => {
  isChartAnimationInProgress.value = isAnimationInProgress;
};

const getActiveFilter = (filters: PortfolioChartFilter[] | null) => {
  if (!filters) {
    return '';
  }

  return filters.find(filter => filter.active)?.key;
};

onMounted(getPortfolioChartData);

return { __sfc: true,props, isLoading, hasError, periodFilters, benchmarkFilters, portfolioChartSummary, chartAxisX, chartAxisY, isChartAnimationInProgress, portfolioParams, isChartLoading, isHeaderLoading, getPortfolioChartData, handlePeriodFilterChange, handleBenchmarkFilterChange, handleOnAnimationStateChange, getActiveFilter, RentabilityHeader, PerformanceChart, PerformanceLink }
}

})